import type { P2PSourceBoundaryInput, P2PSourceBoundaryResult } from './types';

export function buildP2PSourcePayload(input: P2PSourceBoundaryInput): P2PSourceBoundaryResult {
  const missing: Array<'submitted_artifact' | 'payer_response'> = [];

  if (!input.submittedArtifact) {
    missing.push('submitted_artifact');
  }

  if (!input.payerResponse) {
    missing.push('payer_response');
  }

  if (missing.length > 0) {
    return { status: 'unavailable', missing };
  }

  const submittedArtifact = input.submittedArtifact!;
  const payerResponse = input.payerResponse!;

  return {
    status: 'available',
    payload: {
      caseId: input.caseId,
      patient: input.patient,
      payer: input.payer,
      surgeon: input.surgeon,
      facility: input.facility ?? null,
      submittedArtifact,
      payerResponse,
      evidenceFacts: [
        ...submittedArtifact.evidenceFacts,
        {
          id: 'payer-denial-response',
          label: 'Payer denial response',
          value: payerResponse.denialText,
          source: 'payer_response',
        },
      ],
    },
  };
}
